<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left"></div>
				<div class="sf-actions__right">
					<sf-button size="sm" line icon="file" :onClick="saveAction">
						{{ getMessage_('MWCC000327') }}
					</sf-button>
				</div>
			</div>
			<div class="sf-table">
				<table>
					<tbody>
						<tr>
							<th class="col-1">번호</th>
							<td class="col-1">
								<el-input :value="selectedRow.partsNo" readOnly :onChange="value => onChange({ key: 'partsNo', value })" />
							</td>
							<th class="col-1">한국어</th>
							<td class="col-1">
								<el-input v-model="selectedRow.partsName" :onChange="value => onChange({ key: 'partsNo', value })" />
								<!-- <el-input v-model="searchCompPopupParams.cpnyNm" :onChange="value => onChange({ key: 'cpnyNm', value })" />
								<span class="unit input-icon"><i class="icon-sf-search" @click="onUserPopup" /></span> -->
							</td>
							<th class="col-1">영어</th>
							<td class="col-1"><el-input v-model="selectedRow.partsEnName" :onChange="value => onChange({ key: 'partsNo', value })" /></td>
						</tr>
						<tr>
							<th>중국어</th>
							<td><el-input v-model="selectedRow.partsZnName" :onChange="value => onChange({ key: 'partsNo', value })" /></td>
							<th>파트 크기</th>
							<td><el-input v-model="selectedRow.partsSize" :onChange="value => onChange({ key: 'partsNo', value })" /></td>
							<th>사용 유무</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="selectedRow.useYn"
									:options="gridUseYnList_"
									:onChange="value => onChange({ key: 'useYn', value })"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as yup from 'yup';
export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: '',
			pprNo: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.array().of(
				yup.object().shape({
					partsNo: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000904')]))
				})
			);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChange({ key, value }) {
			this.setSelectedRow_({ key, value });
		},
		saveAction() {
			const saveListRows = this.addListSaveRows_; //getters
			try {
				//벨리데이션체크
				this.insVali.validateSync(saveListRows);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: () => this.save(saveListRows) }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
		},
		save(saveRows) {
			//console.log('@@@@ saveRows:', saveRows);

			let sendData = {
				status: 1,
				data: saveRows
			};
			/* 나중에 필요할지 몰라서 주석처리함.
			saveRows.forEach(row => {
				let pushSet = {
					varId: row.varId,
					varValue: row.varValue,
					rmk: row.rmk,
					tableState: row.tableState,
					rgtId: '',
					regDt: '',
					chgId: '',
					chgDt: ''
				};
				sendData.data.push(pushSet);
			});
			*/
			//console.log('@@@@ sendData: ', sendData);
			// return

			if (sendData.data != undefined && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setPartsInfo_(sendData)
					.then(value => {
						if (value.message != undefined && value.message != null) {
							this.$sf_toast({
								type: value.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(value.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		addAction() {},
		deleteAction() {},
		onUserPopup() {
			//console.log('SearchView에서 onUserPopup 실행', this.searchCompPopupParams);
			this.$emit('OpenPopup', this.searchCompPopupParams);
		}
	}
};
</script>
